<template>
    <a class="ninja-logo" href="https://ninjatheory.com" target="_blank">
      <h1>Ninja Theory</h1>
    </a>
</template>

<script>

export default {
  name: 'NinjaLogo',
};
</script>

<style lang="scss">
  .ninja-logo {
    background: transparent url('~@/assets/images/ninja-theory-logo.png') no-repeat center center;
    font-size: 0;
    background-size: contain;
    display: block;
    width: 100px;
    height: 23px;

    @include bp($bp--m) {
      width: 150px;
      height: 35px;
    }

    @include bp($bp--xl) {
      width: 200px;
      height: 46px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/NinjaLogo.vue